import React from 'react';
import My015SubInfo from '@/pages/My015Charge/My015SubInfo';
import * as S from './MobileEtcSubInfo.style';
import * as SS from '../MobileEtc.style';
import { useSay015SubInfo } from '@/components/hooks/customs/myPage/useSay015SubInfo';
import ATitle from '@/components/Atom/ATitle';
import Say015NotInfo from '@/components/Organism/MyPage/Say015NotInfo';
import { formatPhoneNumber } from '@/shared/util/format/phoneNumberFormatUtil';
import { formatDateBase } from '@/shared/util/format/dateFormatUtil';
import BaseGuide from '@/components/Atom/BaseGuide';
import { useModalHook } from '@/components/commons/modals/useModalHook';
import { TSay015PageStage } from '@/recoil/atoms/say015Atom';
import BaseButton from '@/components/Atom/BaseButton';

const MobileEtcSubInfo = () => {
  const subHooks = useSay015SubInfo();
  const { warningModal } = useModalHook();

  const onClickInfoButton = (e: any, state: TSay015PageStage) => {
    switch (state) {
      case '정기구독':
        return subHooks.onClickSubinfoBtn(e);
      case '단기구독':
        return subHooks.postResub015Handle(e);
      case '구독만료':
        return subHooks.onClickNaviSubscription();
      default:
        return warningModal('실패', '새로고침 후 시도해주세요.', true);
    }
  };

  const getButtonText = (state: TSay015PageStage) => {
    switch (state) {
      case '정기구독':
        return '구독해지';
      case '단기구독':
        return '구독유지';
      case '구독만료':
        return '구독신청';
      default:
        return '';
    }
  };

  const buttonText = getButtonText(subHooks.pageState ?? '미가입') as TSay015PageStage;

  return (
    <S.MobileEtcSubInfoContainer className="mobileEtcSubInfo">
      <SS.AWrapper className="basicTable">
        <SS.TitleWrapper className="titleWrap">
          <ATitle type="sub" text="015 구독 정보" />
        </SS.TitleWrapper>
        {subHooks.pageState === '미가입' ? (
          <Say015NotInfo subHooks={subHooks} />
        ) : (
          <SS.MyPageTable className="tw30">
            <tbody>
              {/* 유저 이름 */}
              <tr>
                <th>이름</th>

                <td>{subHooks.user}</td>
              </tr>
              {/* 015 발급 번호 */}
              <tr>
                <th>015 번호</th>

                <td>{formatPhoneNumber(subHooks.authorityData?.number015)}</td>
              </tr>
              {/* 이용기간 */}

              {subHooks.pageState === '정기구독' && (
                <>
                  <tr>
                    <th>이용기간</th>
                    <td>
                      {formatDateBase(subHooks.authorityData?.subsStartDate)} ~{' '}
                      {/* {formatDateBase(subHooks.authorityData?.subsEndDate)} */}
                    </td>
                  </tr>
                  <tr>
                    <th>자동 결제일</th>
                    <td>{formatDateBase(subHooks.authorityData?.subsEndDate)}</td>
                  </tr>
                  <tr>
                    <th>구독 상태</th>
                    <td>구독중</td>
                  </tr>
                </>
              )}
              {subHooks.pageState === '단기구독' && (
                <>
                  <tr>
                    <th>이용기간</th>
                    <td>
                      {formatDateBase(subHooks.authorityData?.subsStartDate)} ~{' '}
                      {formatDateBase(subHooks.authorityData?.subsEndDate)}
                    </td>
                  </tr>
                  <tr>
                    <th>구독 만료일</th>
                    <td>{formatDateBase(subHooks.authorityData?.subsEndDate)}</td>
                  </tr>
                  <tr>
                    <th>구독 상태</th>
                    <td>구독 해지</td>
                  </tr>
                </>
              )}
              {subHooks.pageState === '구독만료' && (
                <>
                  <tr>
                    <th>이용기간</th>
                    <td>
                      {formatDateBase(subHooks.authorityData?.subsStartDate)} ~{' '}
                      {formatDateBase(subHooks.authorityData?.subsEndDate)}
                    </td>
                  </tr>
                  <tr>
                    <th>구독 상태</th>
                    <td>미구독</td>
                  </tr>
                </>
              )}
            </tbody>
          </SS.MyPageTable>
        )}
      </SS.AWrapper>
      <SS.ButtonWrapper>
        {subHooks.pageState && (
          <BaseButton
            width="10rem"
            fontSize="1.4rem"
            padding=".6rem 1rem"
            fontWeight="bold"
            disabled={subHooks.btnState}
            onClick={(e) => onClickInfoButton(e, subHooks.pageState as TSay015PageStage)}
          >
            {buttonText}
          </BaseButton>
        )}
      </SS.ButtonWrapper>
      <BaseGuide text="이용기간 동안 서비스 이용이 가능합니다." />
    </S.MobileEtcSubInfoContainer>
  );
};
export default MobileEtcSubInfo;
